import {
  BarChartOutlined,
  SafetyCertificateOutlined,
  CalendarOutlined,
  FileTextOutlined,
  UserOutlined,
  TeamOutlined,
  IdcardOutlined,
  BugOutlined,
  DatabaseOutlined,
  GlobalOutlined,
  FileSearchOutlined,
  ClusterOutlined,
  SolutionOutlined,
  TagOutlined,
  BuildOutlined,
  EditOutlined,
  ContactsOutlined,
  PhoneOutlined,
  ThunderboltOutlined,
  AuditOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";

const link = (key, label, icon, to) => ({
  key,
  icon,
  label: <Link to={to}>{label}</Link>,
});

const items = [
  link("1", "Estadísticas", <BarChartOutlined />, "/"),
  link("2", "Verificaciones", <AuditOutlined />, "/verificaciones"),
  link("3", "Calendario", <CalendarOutlined />, "/calendario"),
  link("4", "Cotizaciones", <FileTextOutlined />, "/cotizaciones"),
  link("5", "Clientes", <UserOutlined />, "/clientes"),
  link("6", "Personas", <TeamOutlined />, "/personas"),
  link("7", "Usuarios", <IdcardOutlined />, "/usuarios"),
  {
    key: "sub1",
    label: "Catálogos",
    icon: <DatabaseOutlined />,
    children: [
      link("9", "Nacionalidades", <GlobalOutlined />, "/catalogos/nacionalidades"),
      link("10", "Objetos de Solicitud", <FileSearchOutlined />, "/catalogos/objetos-solicitud"),
      link("11", "SCIAN", <ClusterOutlined />, "/catalogos/scian"),
      link("12", "Tipos de Concentración", <SolutionOutlined />, "/catalogos/tipos-concentracion"),
      link("13", "Tipos de Dato", <TagOutlined />, "/catalogos/tipos-dato"),
      link("14", "Tipos de Instalación", <BuildOutlined />, "/catalogos/tipos-instalacion"),
      link("16", "Tipos de Persona", <ContactsOutlined />, "/catalogos/tipos-persona"),
      link("17", "Tipos de Teléfono", <PhoneOutlined />, "/catalogos/tipos-telefono"),
      link("18", "Tipos de Tensión", <ThunderboltOutlined />, "/catalogos/tipos-tension"),
      link("19", "Tipos de Verificación", <AuditOutlined />, "/catalogos/tipos-verificacion"),
    ],
  },
];

// Map path → key for active detection in SideMenu
export const pathToKey = {
  "/":                              "1",
  "/verificaciones":                "2",
  "/calendario":                    "3",
  "/cotizaciones":                  "4",
  "/clientes":                      "5",
  "/personas":                      "6",
  "/usuarios":                      "7",
  "/catalogos/nacionalidades":      "9",
  "/catalogos/objetos-solicitud":   "10",
  "/catalogos/scian":               "11",
  "/catalogos/tipos-concentracion": "12",
  "/catalogos/tipos-dato":          "13",
  "/catalogos/tipos-instalacion":   "14",
  "/catalogos/tipos-persona":       "16",
  "/catalogos/tipos-telefono":      "17",
  "/catalogos/tipos-tension":       "18",
  "/catalogos/tipos-verificacion":  "19",
};

export default items;